import '../Header.css';

/** LOGOS **/
import close from '../../img/iconos/close.svg';
import checkNaranja from '../../img/iconos/check-naranja.svg';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { IonIcon, IonGrid, IonRow, IonCol, IonItem, IonLabel, IonToggle, IonButton, IonLoading } from '@ionic/react';
import { UserGroup } from '../../interfaces/intGroups';
import { getData } from '../../api/apiRecursos';
import Cookies from 'js-cookie';
import { ActivityGroup } from '../../interfaces/intActivity';
import axios from 'axios';


interface Props {
  setCopyModal?: any;
  resourceId: number,
  setTextAlertMvl: any,
  setShowAlertMvl: any,
}

const CopyResource: React.FC<Props> = ({ setTextAlertMvl: setTextAlert, setShowAlertMvl: setShowAlert, setCopyModal, resourceId: resourceId }) => {
  const [loading, setLoading] = useState(false);
  const [userGroup, setUserGroup] = useState<ActivityGroup[]>([]);
  const [groupArray, setGroupArray] = useState<number[]>([]);

  const userData = {
    token: Cookies.get('token'),
    resource_id: resourceId
  }

  useEffect(() => {
    getData.post<ActivityGroup>('/getMyGroupsResource', userData)
      .then(resp => {
        //@ts-ignore
        setUserGroup(resp.data);
      })
      .catch(err => console.log(err));
  }, []);

  const setCopy = () => {
    setLoading(true);
    groupArray.forEach(element => {
      const dataRelation = {
        resource_id: resourceId,
        group_id: element
      };

    // if (state == false) {
    getData.post("/resource/storeCopy", dataRelation)
      .then((res: any) => {
        // alert("objetivo creado correctamente");
        setCopyModal(false);
      })
      .then((res: any) => {
        setTextAlert('Recurso copiado correctamente.');
        setShowAlert(true);
      })
      .catch((error: any) => {
        console.log("error", error);
      });

    });
    setLoading(false)
    // }
  }


  const setSelected = (id: number) => {

    var element = document.getElementById('group-' + id);

    if (element?.classList.contains('selected')) {
      element.classList.remove('selected');
      for (var i = 0; i < groupArray.length; i++) {
        if (groupArray[i] === id) {
          setGroupArray(groupArray.splice(i, 1));
        }
      }
    } else {
      setGroupArray([...groupArray, id]);
      element!.classList.add('selected');
    }
  }

  return (
    <div className="modal modal_copy">
      <div className="modal_content">
      <IonLoading
        isOpen={loading}
        onDidDismiss={() => setLoading(false)}
        message={'Copiando actividades'}
        spinner={'bubbles'}
        showBackdrop={true}
        duration={5000}
      />
        <IonIcon src={close} className="close" onClick={e => setCopyModal(false)} />
        <IonGrid>
          <IonRow>
            <IonCol>
              <h5>Copiar recurso a usuario</h5>
            </IonCol>
          </IonRow>

          {userGroup.map((group, index) =>
            <IonRow className="p-2" key={index}>
              <IonCol className="lineal-flex mx-4 border-bottom">
                {/* {document.getElementById('group-' + group.id)?.classList.contains('selected') ? <img className="medio mx-3" src={checkNaranja} /> : */}
                 {/* <img className="medio mx-3" src={''} />
                 } */}
                <a className={`${group.role == 1 ? 'no-link' : ''}`} onClick={e => <> {group.role != 1 ? setSelected(group.id) : null}</>}>
                  <p id={`group-${group.id}`} className={`group-selector body2 capitalize ${group.role == 1 ? 'text-gris' : null}`}> <img className="medio mx-3" src={checkNaranja} /> {group.name}</p>
                </a>
              </IonCol>
            </IonRow>
          )}

          <IonRow>
            <IonCol className="d-flex justify-content-end mt-5">
              <IonButton className="cancelBtn" onClick={e => setCopyModal(false)}><p>CANCELAR</p></IonButton>
              <IonButton className="saveBtn" disabled={false} onClick={e => setCopy()}><p>Copiar</p></IonButton>
            </IonCol>
          </IonRow>

        </IonGrid>
      </div>
    </div>
  );

};
export default CopyResource;